import { useAtom } from 'jotai';
import { analysisModeAtom, autoDeleteAtom } from '@/hooks/atoms';
import { Button } from '@/components/ui/button';

export default function AnalysisOptionsPanel() {
  const [mode, setMode] = useAtom(analysisModeAtom);
  const [autoDelete, setAutoDelete] = useAtom(autoDeleteAtom);

  return (
    <div className="space-y-4">
      <div>
        <label className="text-sm font-medium text-foreground">Analysis Mode</label>
        <div className="flex gap-2 mt-1.5">
          <Button variant={mode === 'standard' ? 'default' : 'outline'} size="sm" onClick={() => setMode('standard')}>
            Standard
          </Button>
          <Button variant={mode === 'deep' ? 'default' : 'outline'} size="sm" onClick={() => setMode('deep')}>
            Deep
          </Button>
        </div>
        <p className="text-xs text-muted-foreground mt-1">
          {mode === 'standard'
            ? 'Faster analysis with standard detection'
            : 'Deeper analysis with more modules and denser sampling'}
        </p>
      </div>

      <div className="flex items-center gap-2">
        <button
          type="button"
          role="switch"
          aria-checked={autoDelete}
          onClick={() => setAutoDelete(!autoDelete)}
          className={`
            relative inline-flex h-5 w-9 items-center rounded-full transition-colors
            ${autoDelete ? 'bg-primary' : 'bg-muted-foreground/30'}
          `}
        >
          <span
            className={`
              inline-block h-4 w-4 rounded-full bg-white shadow transition-transform
              ${autoDelete ? 'translate-x-[18px]' : 'translate-x-0.5'}
            `}
          />
        </button>
        <label className="text-sm text-foreground">Auto-delete after analysis</label>
      </div>
    </div>
  );
}
